<template>
  <div v-if="ready && itinerario !== undefined && itinerario !== null">
    <div class="section text-black pt-3">
      <i class="bi bi-arrow-left ml-3 goBackArrow" v-on:click="goBack()"></i>
      <div class="mt-4">
        <div class="row text-center mx-0">
          <div class="col-lg-5 col-md-12 px-3 px-lg-5">
            <div style="height: 100%; text-align: left">
              <h5 class="postcardpercorsi__title orange">
                <b>Dettagli - </b>

                <b v-if="this.itinerario !== null" class="title pt-0">
                  {{ this.itinerario["geo:Titolo_it"][0]["@value"] }}
                </b>
                <b v-else class="title pt-0">Itinerario senza nome</b>
              </h5>

              Il tempo totale include anche gli spostamenti da un'area
              all'altra.

              <div class="mt-3 postcardpercorsi__bar" style="height: 4px"></div>
              <h6>Descrizione</h6>

              <div
                class="postcardpercorsi__preview-txt mb-3 text-justify"
                v-if="itinerario['dcterms:description'] !== undefined"
              >
                {{ itinerario["dcterms:description"][0]["@value"] }}
              </div>
              <div class="postcardpercorsi__preview-txt mb-3" v-else>
                Nessuna descrizione disponibile
              </div>

              <h6>
                <template
                  v-if="
                    getInterestList(itinerario['geo:appartiene_a_ambito'])
                      .length > 1
                  "
                  >Interessi:
                </template>
                <template v-else>Interesse: </template>
                <span class="font-weight-normal">{{
                  getInterestList(itinerario["geo:appartiene_a_ambito"]).join(
                    ", "
                  )
                }}</span>
              </h6>
              <div
                class="mt-3"
                v-if="Object.keys(totalTimeObject).length === 0 || timeIsZero"
              >
                <h6><i class="bi bi-clock mr-2"></i> Durata non disponibile</h6>
              </div>
              <div v-else class="mt-3">
                <h6
                  class="card-title"
                  v-if="
                    parseInt(totalTimeObject.hours) === 1 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ totalTimeObject.hours }} ora
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) === 1"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ora e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6
                  class="card-title"
                  v-else-if="
                    parseInt(totalTimeObject.hours) > 0 &&
                    parseInt(totalTimeObject.minutes) === 0
                  "
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore
                </h6>
                <h6
                  class="card-title"
                  v-else-if="parseInt(totalTimeObject.hours) > 0"
                >
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.hours) }} ore e
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
                <h6 class="card-title" v-else>
                  <i class="bi bi-clock mr-2"></i>
                  {{ parseInt(totalTimeObject.minutes) }} minuti
                </h6>
              </div>

              <div class="row mt-3">
                <div class="col-12">
                  <Button
                    type="primary"
                    size="small"
                    v-on:click="sendEmail()"
                    class="button_font"
                    >Prenota Itinerario
                  </Button>
                </div>
              </div>

              <hr />

              <div
                class="col-lg-8 col-sm-12 pr-3 d-sm-block d-md-block d-lg-none mb-4"
              >
                <div class="row">
                  <div class="col-12 d-flex">
                    <div
                      class="mb-2 mx-auto mt-0 aree__tagbox"
                      :class="{
                        'w-100': !isLarge,
                      }"
                    >
                      <button
                        :class="
                          selectedTab === 'ElencoAttività'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'ElencoAttività'"
                      >
                        Elenco delle attività
                      </button>
                      <button
                        :class="
                          selectedTab === 'Mappa'
                            ? 'tag__item__selected'
                            : 'tag__item__unselected'
                        "
                        v-on:click="selectedTab = 'Mappa'"
                      >
                        Mappa
                      </button>
                    </div>
                  </div>

                  <div
                    class="col-12 px-0"
                    v-if="selectedTab === 'ElencoAttività'"
                  >
                    <div v-if="allLoaded">
                      <div v-if="!showDetails" class="mb-4">
                        <div v-if="itinerario.poi.length > 0">
                          <div class="d-sm-block d-md-none d-lg-none">
                            <ElencoPoiSm
                              :itinerario="itinerario"
                              v-on:selectMarkerOnMap="selectMarkerOnMap"
                              v-on:selectMarkerOnMapIstitutoMosso="
                                selectMarkerOnMapIstitutoMosso
                              "
                            ></ElencoPoiSm>
                          </div>
                          <div class="d-md-block d-sm-none d-lg-none col-12">
                            <ElencoPoiMdLg
                              :itinerario="itinerario"
                              v-on:selectMarkerOnMap="selectMarkerOnMap"
                              v-on:selectMarkerOnMapIstitutoMosso="
                                selectMarkerOnMapIstitutoMosso
                              "
                              :screenSize="'medium'"
                              v-if="isLarge"
                            ></ElencoPoiMdLg>
                          </div>
                        </div>
                        <div v-else>
                          Attualmente non sono presenti attività in questo
                          itinerario
                        </div>
                      </div>
                      <div v-else>
                        <div class="row mt-2">
                          <div class="col-12">
                            <i
                              class="bi bi-arrow-left ml-3 mb-5"
                              style="
                                font-size: 1.2rem; 
                                color: black;
                                cursor: pointer;
                              "
                              v-on:click="goBackAndResetMarkersIcon()"
                            >
                              Visualizza elenco attività nell'itinerario</i
                            >
                            <div class="mt-4 text-center">
                              <esperimento
                                class="align-top text-center"
                                :item="activitySelectedForInfo"
                                v-if="activitySelectedForInfo !== null"
                                :screenSize="'mobile'"
                                :hasCorrectAmbito="true"
                              ></esperimento>

                              <visita
                                class="align-top text-center"
                                :item="activityVisitPOISelectedForInfo"
                                v-if="activityVisitPOISelectedForInfo !== null"
                                :screenSize="'mobile'"
                              ></visita>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="loader">
                        <svg class="circular">
                          <circle
                            class="path"
                            cx="50"
                            cy="50"
                            r="20"
                            fill="none"
                            stroke-width="5"
                            stroke-miterlimit="10"
                          ></circle>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 px-0 mx-0" v-if="selectedTab === 'Mappa'">
                    <l-map
                      style="height: 700px; border-radius: 10px"
                      :zoom="zoom"
                      :center="centerMap"
                      ref="mappaSottoItinerario"
                    >
                      <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                      ></l-tile-layer>
                      <l-marker
                        v-for="(marker, index) in markers"
                        :lat-lng="marker.marker.getLatLng()"
                        :key="'marker' + index"
                      >
                        <l-icon
                          :icon-anchor="dynamicAnchor"
                          v-if="marker.poiSelected"
                          :icon-url="
                            require('../icons/inItineraryWatchedPOI.svg')
                          "
                        ></l-icon>
                        <l-icon
                          :icon-anchor="dynamicAnchor"
                          v-if="!marker.poiSelected"
                          :icon-url="require('../icons/marker_dark.svg')"
                        ></l-icon>
                        <l-popup
                          :options="anchorOptions"
                          style="max-width: 250px"
                        >
                          <div class="px-3">
                            <div class="row">
                              <h5>{{ marker.POItitle }}</h5>
                            </div>
                            <div
                              class="row text-justify fadeeffect"
                              style="max-height: 100px; overflow: scroll"
                            >
                              {{ marker.POIdescription }}
                            </div>
                            <div
                                v-for="(link, index) in marker.links"
                                :key="link['@value']"
                                class="row text-justify fadeeffect"
                                :class="index === 0 ? 'mt-3' : 'mt-1'"
                                style="max-height: 100px; overflow: scroll"
                            >
                              <a :href="getLink(link['@value'])" style="color: #5486a8 !important;">{{getLinkName(link['@value'])}}</a>
                            </div>
                            <div
                              class="row mt-3"
                              style="height: 170px; overflow: scroll"
                            >
                              <div class="col-12 text-center">
                                <img
                                  v-if="marker.image !== undefined"
                                  class="margin-auto"
                                  v-img="{
                                    group:
                                      getGroupNameMarker(marker) + 'Mobile',
                                  }"
                                  style="border-radius: 5px"
                                  :src="marker.image"
                                  :alt="marker.POItitle"
                                />
                                <img
                                  v-else
                                  class="postcard__img"
                                  src="@/assets/images/bg3.jpg"
                                  v-img="{
                                    group:
                                      getGroupNameMarker(marker) + 'Mobile',
                                  }"
                                  style="border-radius: 5px"
                                  :alt="marker.POItitle"
                                />
                              </div>
                            </div>
                          </div>
                        </l-popup>
                      </l-marker>

                      <!-- <l-control>
                        <div class="legend">
                          <h4>Legenda</h4>
                          <i style="background: #e35747"></i><span>Luogo con l'attività selezionata</span><br />
                          <i style="background: #437fc5"></i><span>Luogo presente nell'itinerario</span><br />
                        </div>
                      </l-control> -->
                    </l-map>
                  </div>
                </div>
              </div>

              <!--Desktop view-->
              <div class="d-none d-lg-block d-md-none">
                <div v-if="allLoaded" class="col-12">
                  <div v-if="!showDetails" class="mb-4">
                    <div v-if="itinerario.poi.length > 0">
                      <ElencoPoiMdLg
                        :itinerario="itinerario"
                        v-on:selectMarkerOnMap="selectMarkerOnMap"
                        v-on:selectMarkerOnMapIstitutoMosso="
                          selectMarkerOnMapIstitutoMosso
                        "
                        :screenSize="'large'"
                      ></ElencoPoiMdLg>
                    </div>
                    <div v-else>
                      Attualmente non sono presenti attività in questo
                      itinerario
                    </div>
                  </div>
                  <div v-else>
                    <div class="row mt-2">
                      <div class="col-12">
                        <i
                          class="bi bi-arrow-left ml-3"
                          style="
                            font-size: 1.2rem;
                            color: black;
                            cursor: pointer;
                          "
                          v-on:click="goBackAndResetMarkersIcon()"
                        >
                          Visualizza elenco attività nell'itinerario</i
                        >
                        <div class="mt-4 text-center">
                          <esperimento
                            class="align-top text-center"
                            :item="activitySelectedForInfo"
                            v-if="activitySelectedForInfo !== null"
                            :hasCorrectAmbito="true"
                            :screenSize="'desktop'"
                          ></esperimento>
                          <visita
                            class="align-top text-center"
                            :item="activityVisitPOISelectedForInfo"
                            v-if="activityVisitPOISelectedForInfo !== null"
                            :screenSize="'desktop'"
                          ></visita>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="loader">
                    <svg class="circular">
                      <circle
                        class="path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke-width="5"
                        stroke-miterlimit="10"
                      ></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 pr-3 d-none d-lg-block">
            <div class="row px-4">
              <div class="col-12">
                <l-map
                  style="height: 830px; border-radius: 10px"
                  :zoom="zoomLarge"
                  :center="centerMap"
                  ref="mappaSottoItinerario"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker
                    v-for="(marker, index) in markers"
                    :lat-lng="marker.marker.getLatLng()"
                    :key="'marker' + index"
                  >
                    <l-icon
                      :icon-anchor="dynamicAnchor"
                      v-if="marker.poiSelected"
                      :icon-url="require('../icons/inItineraryWatchedPOI.svg')"
                    ></l-icon>
                    <l-icon
                      :icon-anchor="dynamicAnchor"
                      v-if="!marker.poiSelected"
                      :icon-url="require('../icons/marker_dark.svg')"
                    ></l-icon>
                    <l-popup :options="anchorOptions" style="max-width: 250px">
                      <div class="px-3">
                        <div class="row">
                          <h5>{{ marker.POItitle }}</h5>
                        </div>
                        <div
                          class="row text-justify fadeeffect"
                          style="max-height: 100px; overflow: scroll"
                        >
                          {{ marker.POIdescription }}
                        </div>
                        <div
                            v-for="(link, index) in marker.links"
                            :key="link['@value']"
                            class="row text-justify fadeeffect"
                            :class="index === 0 ? 'mt-3' : 'mt-1'"
                            style="max-height: 100px; overflow: scroll"
                        >
                          <a :href="getLink(link['@value'])" style="color: #5486a8 !important;">{{getLinkName(link['@value'])}}</a>
                        </div>

                        <div
                          class="row mt-3"
                          style="max-height: 170px; overflow: scroll"
                        >
                          <div class="col-12 text-center">
                            <img
                              v-if="marker.image !== undefined"
                              class="margin-auto"
                              v-img="{ group: getGroupNameMarker(marker) }"
                              style="border-radius: 5px"
                              :src="marker.image"
                              :alt="marker.POItitle"
                            />
                            <img
                              v-else
                              class="postcard__img"
                              src="@/assets/images/bg3.jpg"
                              v-img="{ group: getGroupNameMarker(marker) }"
                              style="border-radius: 5px"
                              :alt="marker.POItitle"
                            />
                          </div>
                        </div>
                      </div>
                    </l-popup>
                  </l-marker>

                  <!--<l-control>
                    <div class="legend">
                      <h4>Legenda</h4>
                      <i style="background: #e35747"></i><span>Luogo con l'attività selezionata</span><br />
                      <i style="background: #437fc5"></i><span>Luogo presente nell'itinerario</span><br />
                    </div>
                  </l-control>-->
                </l-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ScrollTopArrow :createItinerary="false"></ScrollTopArrow>
  </div>
</template>
<script>
const Common = require("@/Common.vue").default;

import store from "../store";
import $ from "jquery";
import {
  LMap,
  LMarker,
  LPopup,
  LIcon,
  LTileLayer,
  LControl,
} from "vue2-leaflet";
import esperimento from "../components/customComponents/esperimento";
import visita from "../components/customComponents/visita";
import router from "../router";
import { Button } from "element-ui";
import { config } from "../utils/config";
import svgWalking from "../components/customComponents/svg/svgWalking";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";
import { isMobile } from "mobile-device-detect";
import ElencoPoiMdLg from "../components/customComponents/itinerarioPredefinito/ElencoPoiMdLg";
import ElencoPoiSm from "../components/customComponents/itinerarioPredefinito/ElencoPoiSm";

export default {
  name: "sintesiitinerariopredefinito",
  bodyClass: "strumenti-esperimenti-page",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    //LControl,
    Button,
    esperimento,
    visita,
    // svgWalking,
    ScrollTopArrow,
    ElencoPoiMdLg,
    ElencoPoiSm,
  },
  data() {
    return {
      itinerario: null,
      allLoaded: false,
      itinerarioLoaded: false,
      activitySelectedForInfo: null,
      activityVisitPOISelectedForInfo: null,
      visitPOIselectedforInfo: "",
      windowWidth: 0,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 16,
      zoomLarge: 11,
      center: [45.47724690648075, 7.888264286334166],
      map: null,
      markers: [],
      markersPolylines: [],
      anchorOptions: { offset: L.point(-6.5, -37) },
      isMobile: null,
      showDetails: false,

      selectedTab: "ElencoAttività",

      totalTimeObject: {},
      isGeodidalab: false,

      poiInCurrentItinerary: [],
      config: null,
      ready: false,
    };
  },

  beforeCreate() {
    this.isGeodidalab = config.isGeodidalab;
  },

  beforeMount() {
    this.config = config;
    this.ready = true;

    //console.log("PARAMETRO ID: " + this.$route.params.id);
    //console.log(this.$route.params.id);

    if(this.$route.params.id) {
      if (this.$store.state.itinerari.length > 0) {
        //console.log("this.$store.state.itinerari");
        //console.log(this.$store.state.itinerari.length);
        this.itinerario = this.$store.state.itinerari.find((itinerario, index) => {
          //console.log("index: " + index);
          //console.log(itinerario["o:id"]);
          return itinerario["o:id"] === parseInt(this.$route.params.id)
        });

        //console.log("1 - THIS.ITINERARIO");
        //console.log(this.itinerario);

        if(this.itinerario === undefined){
          router.push({ path: "/elencopercorsi", replace: true });
        } else {
          this.fetchData();
        }
      } else{
        var self = this;

        Common.getElemsByClass(self, config.omekaIDs.omekaIDarea, (res) => {
          store.state.aree = res.body;
          self.isLoadingAree = false;

          //chiedo gli itinerari
          Common.getElemsByClass(self, config.omekaIDs.omekaIDitinerario, (res) => {
            store.state.itinerari = res.body;

            store.state.itinerari.sort(
                (a, b) =>
                    a["geo:Posizione_itinerario"][0]["@value"] -
                    b["geo:Posizione_itinerario"][0]["@value"]
            );

            self.mediaLoadedForItinerary = new Array(
                store.state.itinerari.length
            ).fill(false);

            Array.prototype.forEach.call(
                store.state.itinerari,
                (itinerario, index) => {
                  /*chiedo l'immagine degli itinerari*/
                  Common.getElementImages(self, itinerario, (mediaList) => {
                    this.$set(itinerario, "media", mediaList);
                    self.mediaLoadedForItinerary[index] = true;
                  });
                }
            );

            self.loadedAllImages = true;

            //console.log("2 - this.$store.state.itinerari");
            //console.log(store.state.itinerari);

            this.itinerario = store.state.itinerari.find(itinerario => {
              //console.log(itinerario["o:id"]);
              return itinerario["o:id"] === parseInt(this.$route.params.id)
            });


            //console.log("2 - THIS.ITINERARIO");
            //console.log(this.itinerario);

            if(this.itinerario === undefined){
              router.push({ path: "/elencopercorsi", replace: true });
            } else {
              this.fetchData();
            }
          });

          self.loadedAllItinararies = true;
        });

      }


    } else {
      router.push({ path: "/elencopercorsi", replace: true });
    }

    /*
    var itinerarioPredefinito = JSON.parse(
      sessionStorage.getItem("itinerarioPredefinito")
    );

    if (itinerarioPredefinito === null) {
      router.push({ path: "/elencopercorsi", replace: true });
    } else {
      this.itinerario = null;
      this.itinerario = JSON.parse(
        sessionStorage.getItem("itinerarioPredefinito")
      );

      console.log("THIS.ITINERARIO");
      console.log(this.itinerario);
    }

     */
  },

  mounted() {
    this.isMobile = isMobile;
    this.config = config;

      this.getCostMatricesOmeka();

  },

  methods: {
    getCostMatricesOmeka() {
      Common.getElemsByClass(
          this,
          config.omekaIDs.omekaIDmatriciSpostamenti,
          (res) => {
            store.state.omekaCsvMatrixes = res.body;
            store.commit("initCostMatrixPOI");
            store.commit("initCostMatrixAreas");
          }
      );
    },
    getInterestList(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"]);
      }

      return newList;
    },
    goBack() {
      router.go(-1);
    },
    getGroupName(item) {
      return item["geo:Titolo_it"][0]["@value"].replaceAll('"', "");
    },
    getGroupNameMarker(marker) {
      return marker.POItitle.replaceAll('"', "");
    },

    sendEmail() {
      var emailAddress = "info@geodidalab.it";
      var subject =
        "Richiesta informazioni " +
        this.itinerario["geo:Titolo_it"][0]["@value"];
      var body =
        "Gentile GeoDidaLab, siamo interessati alla realizzazione dell'itinerario nell'oggetto. \nAttendiamo un gentile riscontro.";

      var mail = document.createElement("a");
      mail.href =
        "mailto:" + emailAddress + "?subject=" + subject + "&body=" + body;
      mail.click();
    },

    showInfoAtivity(poiName, activityName, areaname) {
      Array.prototype.forEach.call(
        this.itinerario.poiGroupedByArea[areaname],
        (poiInArea) => {
          Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
            if (
              poiInArea["geo:Titolo_it"][0]["@value"] ===
              poi["geo:Titolo_it"][0]["@value"]
            ) {
              if (poiInArea.mediaImages === undefined) {
                this.$set(poiInArea, "mediaImages", poi.media);
              }
            }
          });
        }
      );

      if (!activityName.includes("Visita")) {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(
          this.itinerario.poiGroupedByArea[areaname],
          (poi) => {
            Array.prototype.forEach.call(
              poi.activitiesOfPOIPivot,
              (activity) => {
                if (activity["o:title"] === activityName) {
                  this.activitySelectedForInfo = activity;
                }
              }
            );
          }
        );

        this.activityVisitPOISelectedForInfo = null;
      } else {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(
          this.itinerario.poiGroupedByArea[areaname],
          (poi) => {
            if (poi["geo:Titolo_it"][0]["@value"] === poiName) {
              this.activityVisitPOISelectedForInfo = poi;
            }
          }
        );

        this.activitySelectedForInfo = null;
      }
    },

    showInfoAtivityIstitutoMosso(poiName, activityName) {
      if (!activityName.includes("Visita")) {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
          Array.prototype.forEach.call(poi.activitiesOfPOIPivot, (activity) => {
            if (activity["o:title"] === activityName) {
              this.activitySelectedForInfo = activity;
            }
          });
        });

        this.activityVisitPOISelectedForInfo = null;
      } else {
        this.activityVisitPOISelectedForInfo = null;

        Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
          if (poi.mediaImages === undefined) {
            this.$set(poi, "mediaImages", poi.media);
          }

          if (poi["geo:Titolo_it"][0]["@value"] === poiName) {
            this.activityVisitPOISelectedForInfo = poi;
          }
        });

        this.activitySelectedForInfo = null;
      }
    },

    createMarkerArray() {
      //Punto di partenza
      //this.markersPolylines.push(this.startPoint);

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        if (poi["marker"]) {
          var POIlat = poi["marker"]["o-module-mapping:lat"];
          var POIlng = poi["marker"]["o-module-mapping:lng"];

          var POIcoordinates = [POIlat, POIlng];

          this.markersPolylines.push(POIcoordinates);
        }
      });

      //Punto di arrivo
      //this.markersPolylines.push(this.endPoint);
    },

    initializeMarkersOfFilteredPOI() {
      this.markers = [];

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        //viene usato anche per il punto di arrivo
        var isStartingPoint =
          poi["poiName"] === "Punto di partenza" ||
          poi["poiName"] === "Punto di arrivo";

        //console.log("SCHEDE ESTERNE");
        //console.log(poi['geo:Scheda_esterna']);

        if (isStartingPoint) {
          if (poi["marker"]) {
            this.markers.push({
              marker: L.marker([
                poi["marker"]["o-module-mapping:lat"],
                poi["marker"]["o-module-mapping:lng"],
              ]),
              color: "#1585bd",
              strokeColor: "#1b4f88",
              circleColor: "#ffffff",
              POItitle: poi["geo:Titolo_it"][0]["@value"],
              POIdescription: poi["dcterms:description"]
                ? poi["dcterms:description"]["@value"]
                : "Nessuna descrizione disponibile",
              image: poi["media"][0]
                ? poi["media"][0]["o:thumbnail_urls"]["large"]
                : undefined,
              links: poi['geo:Scheda_esterna'],
              //TODo: aggiungere attributi
              isStartPoint: isStartingPoint,
              poiSelected: false,
            });
          }
        } else {
          if (poi["marker"]) {
            this.markers.push({
              marker: L.marker([
                poi["marker"]["o-module-mapping:lat"],
                poi["marker"]["o-module-mapping:lng"],
              ]),
              color: "#1585bd",
              strokeColor: "#1b4f88",
              circleColor: "#ffffff",
              POItitle: poi["geo:Titolo_it"][0]["@value"],
              POIdescription: poi["dcterms:description"]
                ? poi["dcterms:description"][0]["@value"]
                : "Nessuna descrizione disponibile",
              image: poi["media"][0]
                ? poi["media"][0]["o:thumbnail_urls"]["large"]
                : undefined,
              links: poi['geo:Scheda_esterna'],
              //TODo: aggiungere attributi
              isStartPoint: isStartingPoint,
              poiSelected: false,
            });
          }
        }
      });

      var markerArray = [];

      Array.prototype.forEach.call(this.markers, (firstMarker) => {
        markerArray.push(firstMarker.marker);
      });

      let latlngs = markerArray.map((marker) => marker.getLatLng());
      let latlngBounds = L.latLngBounds(latlngs);

      if (
        Object.keys(latlngBounds).length > 0 &&
        this.$refs.mappaSottoItinerario
      ) {
        this.$refs.mappaSottoItinerario.fitBounds(latlngBounds);
      }

      //this.$refs.mappaSottoItinerarioMobile.fitBounds(latlngBounds);

      this.markersCreated = true;
    },

    selectMarkerOnMap(poiName, activityName, areaName) {
      this.showDetails = true;
      Array.prototype.forEach.call(this.markers, (marker) => {
        if (marker.POItitle === poiName) {
          marker.poiSelected = true;
        } else {
          marker.poiSelected = false;
        }
      });

      this.showInfoAtivity(poiName, activityName, areaName);
    },

    selectMarkerOnMapIstitutoMosso(poiName, activityName) {
      this.showDetails = true;
      Array.prototype.forEach.call(this.markers, (marker) => {
        if (marker.POItitle === poiName) {
          marker.poiSelected = true;
        } else {
          marker.poiSelected = false;
        }
      });

      this.showInfoAtivityIstitutoMosso(poiName, activityName);
    },

    goBackAndResetMarkersIcon() {
      this.showDetails = false;
      Array.prototype.forEach.call(this.markers, (marker) => {
        marker.poiSelected = false;
      });
    },

    msToTime(duration) {
      var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var timeObject = {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: milliseconds,
      };

      return timeObject;
    },

    getCount(i, j) {
      var k = 0;
      var l = 0;
      for (var x = 0; x <= i; x++) {
        for (
          var h = 0;
          h < this.itinerario.poi[x].activitiesOfPOIPivot.length;
          h++
        ) {
          if (x === i) {
            if (l < j) {
              l += 1;
            }
          } else {
            k += 1;
          }
        }
      }

      k += l;

      return k + 1;
    },

    getTimeToNextPOI(poi, nextPOI) {
      var timesFromPOI = [];

      if (poi["geo:appartiene_a_pivot"]) {
        timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
          (p) =>
            parseInt(p["PoiID"]) ===
            poi["geo:appartiene_a_pivot"][0]["value_resource_id"]
        );
      } else {
        timesFromPOI = store.state.costMatricesTimeBetweenPOI.filter(
          (p) =>
            parseInt(p["PoiID"]) ===
            poi["geo:situato_in"][0]["value_resource_id"]
        );
      }

      var timeMillis = 0;
      if (timesFromPOI.length === 0) {
        timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
      } else {
        if (poi["geo:appartiene_a_pivot"]) {
          if (
            timesFromPOI[0][
              nextPOI["geo:appartiene_a_pivot"][0]["value_resource_id"]
            ]
          ) {
            timeMillis =
              timesFromPOI[0][
                nextPOI["geo:appartiene_a_pivot"][0]["value_resource_id"]
              ];
          } else {
            timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
          }
        } else {
          if (
            timesFromPOI[0][nextPOI["geo:situato_in"][0]["value_resource_id"]]
          ) {
            timeMillis =
              timesFromPOI[0][
                nextPOI["geo:situato_in"][0]["value_resource_id"]
              ];
          } else {
            timeMillis = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
          }
        }
      }

      var timeMinutes = timeMillis / 60000;

      if (timeMinutes === 1) {
        return timeMinutes + " minuto";
      } else {
        return timeMinutes + " minuti";
      }
    },

    addPOIToItinerary() {
      var filteredPOI = store.state.POI.filter(
        (x) =>
          x["geo:appartiene_a_itinerario"] !== undefined &&
          x["geo:Posizione_itinerario"] !== undefined
      );
      var POIWithNotItinerary = store.state.POI.filter(
        (x) =>
          x["geo:appartiene_a_itinerario"] === undefined ||
          x["geo:Posizione_itinerario"] === undefined
      );

      var poiInItinerario = filteredPOI.filter(
        (x) =>
          x["geo:appartiene_a_itinerario"][0]["value_resource_id"] ===
          this.itinerario["o:id"]
      );

      //console.log("RIORDINO I POI!!!!");
      //ordino i POI in base alla loro posizione nell'itinerario
      poiInItinerario.sort(
        (a, b) => {
          //console.log(a);
          //console.log(b);
          return a["geo:Posizione_itinerario"][0]["@value"] -
              b["geo:Posizione_itinerario"][0]["@value"];
        }
      );

      //aggiungo i poi all'itinerario
      this.$set(this.itinerario, "poi", poiInItinerario);

      var poiGroupedByArea = poiInItinerario.reduce(function (r, a) {
        r[a["areaDiAppartenenza"][0]["display_title"]] =
          r[a["areaDiAppartenenza"][0]["display_title"]] || [];
        r[a["areaDiAppartenenza"][0]["display_title"]].push(a);
        return r;
      }, Object.create(null));

      this.$set(this.itinerario, "poiGroupedByArea", poiGroupedByArea);
    },

    fetchData() {
      var self = this;
      Common.getElemsByClass(self, config.omekaIDs.omekaIDpoiPIVOT, (res) => {
        store.state.POIpivot = res.body;
        var POIpivot = res.body;

        store.commit("setPOIpivot", {
          POIpivot: POIpivot,
        });

        Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
          if (poi.hasOwnProperty("o-module-mapping:marker")) {
            // Get module-mapping
            Common.getElemByUrl(
              self,
              poi["o-module-mapping:marker"][0]["@id"],
              (r2) => {
                poi.marker = r2.body;
              }
            );
          } else {
            /*Il POI non ha nessuna coordinata*/
          }

          poi.visitPOI = false;
          poi.numberOfActivitiesSelectedInPOI = 0;

          /*chiedo l'immagine dei POI*/
          Common.getElementImages(self, poi, (mediaList) => {
            poi.media = mediaList;
            self.isLoadingPOIPivot = false;
          });
        });

        //console.log("self.itinerario[\"o:id\"]");
        //console.log(self.itinerario);
        //property 213 (geo:appartiene_a_itinerario)
        Common.getElemByPropertyId(
          self,
          config.omekaIDs.omekaIDappartiene_a_itinerario,
          self.itinerario["o:id"],
          (res) => {
            var poi = res.body.filter(
              (poi) => {
                //console.log("CLASS");
                //console.log(poi["o:resource_class"]);
                return poi["o:resource_class"]["o:id"] === config.omekaIDs.omekaIDpoi;
              });

            self.poiInCurrentItinerary = poi;

            //chiedo gli esperimenti perchè magari non sono mai andato nella pagina dedicata a loro prima d'ora, ma mi servono qua
            Common.getElemsByClass(
              self,
              config.omekaIDs.omekaIDattivita,
              (res) => {
                store.state.esperimenti = res.body;
                store.state.loadedActivitiesInPOIPivot = true;

                self.activitiesLoaded = true;
                self.isLoadingEsperimenti = false;

                self.setActivitiesInPOIOfCurrentItinerary();
              }
            );
          }
        );
      });
    },

    setActivitiesInPOIOfCurrentItinerary() {
      var undefinedPresent = false;
      Array.prototype.forEach.call(store.state.POIpivot, (pivot) => {
        if (pivot.mis === undefined) {
          undefinedPresent = true;
        }
      });

      if (undefinedPresent) {
        store.commit("setActivitiesInPOIPivot");
      }

      Array.prototype.forEach.call(this.poiInCurrentItinerary, (poi) => {
        var pivotOfPOI = [];

        if (poi["geo:appartiene_a_pivot"]) {
          pivotOfPOI = store.state.POIpivot.filter(
            (p) =>
              p["o:id"] ===
              poi["geo:appartiene_a_pivot"][0]["value_resource_id"]
          );
        } else {
          pivotOfPOI = store.state.POIpivot.filter(
            (p) => p["o:id"] === poi["geo:situato_in"][0]["value_resource_id"]
          );
        }

        var pivot = pivotOfPOI[0];

        var misurazioniInPivot = pivot.mis;

        //recupero i poi che appartengono all'itinerario corrente
        if (poi.activitiesOfPOIPivot === undefined) {
          poi.activitiesOfPOIPivot = misurazioniInPivot;
        }
        if (poi.marker === undefined) {
          poi.marker = pivot.marker;
        }

        poi.media = pivot.media;

        if (this.isGeodidalab) {
          poi.areaDiAppartenenza = pivot["geo:appartiene_a_area"];
        } else {
          poi.ambitoDiAppartenenza = pivot["geo:appartiene_a_ambito"];
        }

        poi["geo:Durata"] = pivot["geo:Durata"];
        poi["geo:Titolo_it"] = pivot["geo:Titolo_it"];
        poi["geo:Scheda_esterna"] = pivot["geo:Scheda_esterna"];

        poi["dcterms:description"] = pivot["dcterms:description"];
      });

      //QUAAAA

      this.itinerario.poi = this.poiInCurrentItinerary;

      this.setActivitiesInPOIdone = true;

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        var visit = {};
        visit["o:title"] = "Visita " + poi["geo:Titolo_it"][0]["@value"];
        visit["geo:Durata"] = poi["geo:Durata"];
        visit["geo:situato_in"] = poi["geo:appartiene_a_pivot"];

        poi.activitiesOfPOIPivot.unshift(visit);
      });

      this.itinerario.poi.sort(
          (a, b) => {
            //console.log(a);
            //console.log(b);
            return parseInt(a["geo:Posizione_itinerario"][0]["@value"]) -
                parseInt(b["geo:Posizione_itinerario"][0]["@value"]);
          }
      );

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        this.$set(poi, "mediaImages", poi.media);
      });

      this.itinerarioLoaded = true;

      this.totalTimeObject = this.msToTime(this.totalTime);

      this.allLoaded = true;

      this.initializeMarkersOfFilteredPOI();
    },
    getLink(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[1];
      } else {
        return link;
      }
    },
    getLinkName(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[0];
      } else {
        return "Dettagli";
      }
    }
  },

  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },

  computed: {
    dynamicAnchor() {
      return [20, 64 * 0.65];
    },
    leafletMap() {
      return this.$refs.mappaSottoItinerario;
    },
    isLarge() {
      return this.windowWidth >= 768;
    },

    timeIsZero() {
      return (
        this.totalTimeObject.hours === "00" &&
        this.totalTimeObject.minutes === "00" &&
        this.totalTimeObject.seconds === "00" &&
        this.totalTimeObject.milliseconds === 0
      );
    },

    totalTime() {
      var totalTimePOI = 0;

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        for (var i = 0; i < poi.activitiesOfPOIPivot.length; i++) {
          totalTimePOI +=
            parseInt(poi.activitiesOfPOIPivot[i]["geo:Durata"][0]["@value"]) *
            60000;

          if (i > 0) {
            //questo non viene fatto per la visita
            if (poi.activitiesOfPOIPivot[i]["geo:Durata_organizzazione"]) {
              totalTimePOI +=
                parseInt(
                  poi.activitiesOfPOIPivot[i]["geo:Durata_organizzazione"][0][
                    "@value"
                  ]
                ) * 60000;
            } else {
              totalTimePOI += this.config.omekaIDs.defaultOrganizationTime  * 60000;
            }
          }
        }
      });

      var poiIDs = [];

      Array.prototype.forEach.call(this.itinerario.poi, (poi) => {
        if (poi["geo:appartiene_a_pivot"]) {
          poiIDs.push(poi["geo:appartiene_a_pivot"][0]["value_resource_id"]);
        } else {
          poiIDs.push(poi["geo:situato_in"][0]["value_resource_id"]);
        }
      });

      for (var i = 0; i < poiIDs.length - 1; i++) {
        var distancesFromPoiOfIndexI =
          this.$store.state.costMatricesTimeBetweenPOI.filter(
            (poi) => parseInt(poi.PoiID) === poiIDs[i]
          );
        var stringId = String(poiIDs[i + 1]);

        if (distancesFromPoiOfIndexI.length === 0) {
          totalTimePOI += config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
        } else {
          if (distancesFromPoiOfIndexI[0][stringId]) {
            totalTimePOI += distancesFromPoiOfIndexI[0][stringId];
          } else {
            totalTimePOI +=
              config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;
          }
        }
      }

      return totalTimePOI;
    },

    centerMap() {
      var sumLat = 0;
      var sumLng = 0;

      Array.prototype.forEach.call(this.markers, (marker) => {
        sumLat += marker.marker["_latlng"].lat;
        sumLng += marker.marker["_latlng"].lng;
      });

      var middleLat = sumLat / this.markers.length;
      var middleLng = sumLng / this.markers.length;

      if (isNaN(middleLat) || isNaN(middleLng)) {
        return [45.47724690648075, 7.888264286334166];
      } else {
        return [middleLat, middleLng];
      }
    },
  },

  watch: {
    itinerario(newValue, oldValue) {
      if (newValue !== null && newValue.poi) {
        this.createMarkerArray();
        this.initializeMarkersOfFilteredPOI();
      }
    },
    leafletMap(newValue, oldValue) {
      conso.e.log(newValue);
      conso.e.log(oldValue);
    },
  },
};
</script>
<style>
.vertical-line {
  border-left: 3px dashed rgba(201, 201, 201, 0.42);
  height: 40px;
}

.vertical-line-same-poi {
  border-left: 3px solid rgba(201, 201, 201, 0.42);
  height: 30px;
}

.itinerary-card {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  /* box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; */
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px; */
}
</style>
